import { createSelector } from '@ngrx/store';
import {
  getDecedentInfoState,
  getFeatureToggleState,
  getTriageState,
  TransactionState,
} from '@store/reducers';
import { FeatureToggleState } from '@store/reducers/feature/feature.reducer';
import { TriageState } from '@store/reducers/triage/triage.reducer';
import { nullState } from '@store/selectors/router/common/router.selectors';
import {
  selectAllTransactions,
  selectCurrentTransactionId,
  selectIsCurrentTransactionNewAccountTransaction,
  selectIsMultipleNewAccountTransactionExist,
} from '@store/selectors/transaction-state/transaction-state.selectors';
import { selectEmploymentFeature, VgEmploymentState } from 'vg-interaction-model';

import {
  getMultiInheritanceAccountTriageNextPage,
  getMultiInheritanceContactInfoNextPage,
  getMultiInheritanceDecedentInfoRoute,
  getMultiInheritanceEmploymentNextPage,
  getMultiInheritanceIncomeNetWorthNextPage,
  getMultiInheritanceInvestObjNextPage,
  getMultiInheritanceLetterUploadNexPage,
  getMultiInheritanceNewAccountReviewNextPage,
  getMultiInheritancePersonalInfoNextPage,
  getMultiInheritanceReviewNextPage,
  getMultiInheritanceTermsNextPage,
  getMultiInheritanceTriageNextPage,
  getMultiInheritanceTrustTriageNextPage,
  getMultiInheritanceUploadNextPage,
} from './multi-inheritance-router.helpers';

export const selectMultiInheritanceTriageNextPage = createSelector(
  getTriageState,
  getFeatureToggleState,
  (triageState: TriageState, featureToggleState: FeatureToggleState) =>
    getMultiInheritanceTriageNextPage(triageState, featureToggleState),
);

export const selectMultiInheritanceTrustTriageNextPage = createSelector(
  getTriageState,
  getFeatureToggleState,
  (triageState: TriageState, featureToggleState: FeatureToggleState) =>
    getMultiInheritanceTrustTriageNextPage(triageState, featureToggleState),
);

export const selectMultiInheritanceDecedentInfoNextPage = createSelector(
  getDecedentInfoState,
  (decedentInfoState) => getMultiInheritanceDecedentInfoRoute(decedentInfoState),
);

export const selectMultiInheritanceUploadNextPage = createSelector(() =>
  getMultiInheritanceUploadNextPage(),
);

export const selectMultiInheritanceAccountTriageNextPage = createSelector(
  selectIsCurrentTransactionNewAccountTransaction,
  selectIsMultipleNewAccountTransactionExist,
  (isNewAccount, isMultipleNewAccountTransaction) =>
    getMultiInheritanceAccountTriageNextPage(isNewAccount, isMultipleNewAccountTransaction),
);

export const selectMultiInheritancePersonalInfoNextPage = createSelector(() =>
  getMultiInheritancePersonalInfoNextPage(),
);

export const selectMultiInheritanceContactInfoNextPage = createSelector(() =>
  getMultiInheritanceContactInfoNextPage(),
);

export const selectMultiInheritanceEmploymentNextPage = createSelector(
  selectEmploymentFeature,
  (employmentState: VgEmploymentState) => getMultiInheritanceEmploymentNextPage(employmentState),
);

export const selectMultiInheritanceLetterUploadNexPage = createSelector(() =>
  getMultiInheritanceLetterUploadNexPage(),
);

export const selectMultiInheritanceIncomeNetWorthNextPage = createSelector(() =>
  getMultiInheritanceIncomeNetWorthNextPage(),
);

export const selectMultiInheritanceInvestObjNextPage = createSelector(() =>
  getMultiInheritanceInvestObjNextPage(),
);

export const selectMultiInheritanceNewAccountReviewNextPage = createSelector(
  selectCurrentTransactionId,
  (currentTransactionId) => getMultiInheritanceNewAccountReviewNextPage(currentTransactionId),
);

export const selectMultiInheritanceReviewNextPage = createSelector(
  selectAllTransactions,
  (transactions: TransactionState[]) => getMultiInheritanceReviewNextPage(transactions),
);

export const selectMultiInheritanceTermsNextPage = createSelector(nullState, () =>
  getMultiInheritanceTermsNextPage(),
);
